const styles = () => ({
  root: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },

  draggable: {
    position: 'relative',
    margin: '0px 0px 13px 0',
  },

  dragHandle: {
    width: 17,
    height: 10,
    cursor: 'row-resize',
    position: 'absolute',
    top: '50%',
    left: 39,
    marginTop: -5,
  },
});

export default styles;
